import ConsumerInfo from './ConsumerInfo';

export default ConsumerInfo;
